import { handleActions } from 'redux-actions';
import Immutable from 'immutable';
import { 
  LOGIN_REQUEST,
  LOGIN_RESPONSE,
  LOGOUT,
  AUTH_TOKENS_UPDATED,
  LOAD_STORAGE,
  LOGIN_LOADING_REPONSE,
  NAVIGATE_MENU,
  SET_PAYMENT_COMPLETED,
  SET_WIDGET_VALUE,
  SET_HEADER_SEARCH,
  SET_CURRENT_ROUTE,
  SET_USER_NAME
} from '../constants/actions';

import StorageService from '../services/storage';
import Swal from "sweetalert2";
import colors from '../constants/colors';
import { Dimensions } from 'react-native';
const screenHeight = Dimensions.get('window').height;
const buttonHeight = 60; // Height of your button
const initialTopPosition = screenHeight - 2.3 * buttonHeight;

const initialState = {
  username: '',
  authToken: '',
  refreshToken: '',
  loginLoading: false,
  payment_completed: true,
  companyTimezone: '',
  company_id: null,
  companyName: '',
  userRole: '',
  widgetX: 10,
  widgetY: initialTopPosition,
  headerSearch: '',
  currentRoute: '',
};


export default handleActions({
  [LOGIN_REQUEST]: (state, action) => {
    //const { username, password } = action.payload;
    const { username } = action.payload;
    StorageService.set('username', username);
    //LocalStorageDriver.set('password', password);
    return state.set('username', username).set('loginLoading',true);
      //.set('password', password);
  },
  [LOGIN_RESPONSE]: {
    next(state, action) {
      return state;
    },
    throw(state, action) {
      Swal.fire({
        text: 'Login failed',
        confirmButtonText: "OK",
        confirmButtonColor: colors.orange,
        backdrop: false

      });
      return state;
    },
  },
  [LOGIN_LOADING_REPONSE]: {
    next(state, action) {
      return state.set('loginLoading',false);
    },   
  },
  [LOGOUT]: (state, action) => {

    //console.log('***** LOGOUT reducer!');

    StorageService.remove('username');
    StorageService.remove('authToken');
    StorageService.remove('refreshToken');
    StorageService.remove('companyTimezone'); 
    StorageService.remove('company_id');
    StorageService.remove('companyName');
    StorageService.remove('userRole');
    StorageService.remove('allowApproval');

    return state.set('authToken', '')
      .set('companyTimezone', '')
      .set('company_id', '')
      .set('companyName', '')
      .set('userRole', '')
      .set('allowApproval', '')
      .set('refreshToken', '')
      .set('headerSearch', '')
      .set('currentRoute', '');
  },
  [AUTH_TOKENS_UPDATED]: (state, action) => {
    if(action.payload){
    const companyName = action.payload.companyName != null
      ? action.payload.companyName
      : (state.get('companyName') || StorageService.get('companyName') || '');

    StorageService.set('authToken', action.payload.token);
    StorageService.set('refreshToken', action.payload.refresh);
    StorageService.set('companyTimezone', action.payload.companyTimezone);
    StorageService.set('userRole', action.payload.userRole);
    StorageService.set('company_id', action.payload.company_id);
    StorageService.set('companyName', companyName);
    StorageService.set('allowApproval', action.payload.allowApproval); 


    return state.set('authToken', action.payload.token)
      .set('companyTimezone', action.payload.companyTimezone) 
      .set('company_id', action.payload.company_id)
      .set('companyName', companyName)
      .set('userRole', action.payload.userRole)
      .set('refreshToken', action.payload.refresh)
      .set('allowApproval', action.payload.allowApproval);
    }else{
      Swal.fire({
        text: 'Wrong Email and Password',
        confirmButtonText: "OK",
        confirmButtonColor: colors.orange,
        backdrop: false

      });
      return state.set('authToken', '')
      .set('refreshToken', '');
    }
  },
  [LOAD_STORAGE]: (state, action) => {
    //console.log('LOAD STORAGE ********');
    return state.set('authToken', StorageService.get('authToken'))
      .set('companyTimezone', StorageService.get('companyTimezone')) 
      .set('company_id', StorageService.get('company_id'))
      .set('companyName', StorageService.get('companyName') || '')
      .set('userRole', StorageService.get('userRole'))
      .set('refreshToken', StorageService.get('refreshToken'))
      .set('allowApproval', StorageService.get('allowApproval'));
  },
  [NAVIGATE_MENU]: (state, action) => {
    if(action.payload){
      const { token, refresh, payment_completed }= action.payload;
      
      return state.set('authToken', token)
        .set('refreshToken', refresh)
        .set('payment_completed', payment_completed);
    }else{
      return state.set('authToken', '')
        .set('refreshToken', '');
    }

  },
  [SET_PAYMENT_COMPLETED]: (state, action) => {
    const paid = action.payload;
    return state.set('payment_completed', paid);
  }, 
  [SET_WIDGET_VALUE]: (state, action) => {
    const { x, y } = action.payload;
    var newX = x != null ? x : state.get('widgetX');
    var newY = y != null ? y : state.get('widgetY');
    //console.log('newX: ' + newX);
    //console.log('newY: ' + newY);

    return state.set('widgetX', newX).set('widgetY', newY);
  },
  [SET_HEADER_SEARCH]: (state, action) => {
    return state.set('headerSearch', action.payload || '');
  },
  [SET_CURRENT_ROUTE]: (state, action) => {
    return state.set('currentRoute', action.payload || '');
  },
  [SET_USER_NAME]: (state, action) => {
    const { username } = action.payload;
    return state.set('username', username);
  },
}, Immutable.fromJS(initialState));